import Layout from '@app-studio-web/ui/components/Layout'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, Link, useSubmit } from 'react-router-dom'

type ButtonOption = {
  text: React.ReactNode | string
  subtext?: string
  value: string
}

export default function QuestionResetPage() {
  const { t } = useTranslation()
  const submit = useSubmit()
  const [clickedValue, setClickedValue] = useState<string | null>(null)

  // Self-contained content to avoid props in routes
  const heading = t('pages.onboarding.reset.heading')
  const buttons: ButtonOption[] = useMemo(
    () => [
      { text: t('pages.onboarding.reset.button1'), value: 'button1' },
      { text: t('pages.onboarding.reset.button2'), value: 'button2' },
    ],
    [t],
  )
  const withLogin = false

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = 'answer'
    hiddenInput.value = clickedValue || ''
    event.currentTarget.appendChild(hiddenInput)

    submit(event.currentTarget)

    event.currentTarget.removeChild(hiddenInput)
  }

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      {withLogin && (
        <div className="flex shrink-0 items-center justify-end">
          <Link
            className="custom-heading hover:opacity-80"
            to="/account/sign-in"
            data-testid="button-login"
          >
            {t('shared.signIn')}
          </Link>
        </div>
      )}
      <div className="flex h-full flex-col">
        <div className="mt-11 shrink-0">
          <h1 className="custom-heading mb-4" data-testid="label-header">
            {heading}
          </h1>
        </div>

        <div className="flex grow items-end justify-center pb-10">
          <Form
            method="post"
            className="w-full max-w-md"
            onSubmit={handleSubmit}
          >
            <div className="flex flex-col space-y-4">
              {buttons.map((button, index) => (
                <button
                  key={`button-${index}`}
                  type="submit"
                  className={`w-full cursor-pointer rounded-[20px] border bg-transparent bg-white px-6 py-6 text-center text-base hover:opacity-80 ${
                    clickedValue === button.value
                      ? 'border-2 border-gray-400'
                      : 'border-custom-gray'
                  }`}
                  data-testid={`button-option-${index + 1}`}
                  onClick={() => setClickedValue(button.value)}
                >
                  <div className="items-center justify-center">
                    <p className="font-semibold">{button.text}</p>
                    {button.subtext && <p>{button.subtext}</p>}
                  </div>
                </button>
              ))}
            </div>
          </Form>
        </div>
      </div>
    </Layout>
  )
}
